import {
    EstimatedBehaviorCategories,
    EstimatedBehaviorCategory
} from "../estimated_behavior/EstimatedBehaviorCategories";

export enum CommentCategory {
    BATH_COUNT = "BATH_COUNT",
    BATH_TIME = "BATH_TIME",
    DAILY_SLEEP = "DAILY_SLEEP",
    DAILY_SLEEP_COUNT = "DAILY_SLEEP_COUNT",
    LAUNDRY_COUNT = "LAUNDRY_COUNT",
    LAUNDRY_TIME = "LAUNDRY_TIME",
    MEAL_COUNT = "MEAL_COUNT",
    MEAL_TIME = "MEAL_TIME",
    NIGHTLY_TOILET_COUNT = "NIGHTLY_TOILET_COUNT",
    NIGHTLY_LAUNDRY = "NIGHTLY_LAUNDRY",
    NIGHTLY_SWEEPING = "NIGHTLY_SWEEPING",
    NIGHTLY_TV = "NIGHTLY_TV",
    NIGHTLY_SLEEP_TIME = "NIGHTLY_SLEEP_TIME",
    NIGHTLY_SLEEP_COUNT = "NIGHTLY_SLEEP_COUNT",
    SWEEPING_COUNT = "SWEEPING_COUNT",
    SWEEPING_TIME = "SWEEPING_TIME",
    TOILET_COUNT = "TOILET_COUNT",
    TOILET_TIME = "TOILET_TIME",
    TV_TIME = "TV_TIME",
}

export const CommentCategoryList = [
    CommentCategory.BATH_COUNT,
    CommentCategory.BATH_TIME,
    CommentCategory.DAILY_SLEEP,
    CommentCategory.DAILY_SLEEP_COUNT,
    CommentCategory.LAUNDRY_COUNT,
    CommentCategory.LAUNDRY_TIME,
    CommentCategory.MEAL_COUNT,
    CommentCategory.MEAL_TIME,
    CommentCategory.NIGHTLY_TOILET_COUNT,
    CommentCategory.NIGHTLY_LAUNDRY,
    CommentCategory.NIGHTLY_SWEEPING,
    CommentCategory.NIGHTLY_TV,
    CommentCategory.NIGHTLY_SLEEP_TIME,
    CommentCategory.NIGHTLY_SLEEP_COUNT,
    CommentCategory.SWEEPING_COUNT,
    CommentCategory.SWEEPING_TIME,
    CommentCategory.TOILET_COUNT,
    CommentCategory.TOILET_TIME,
    CommentCategory.TV_TIME,
];

const mapValueToCategory: { [key in string]: CommentCategory } = {
    "BATH_COUNT": CommentCategory.BATH_COUNT,
    "BATH_TIME": CommentCategory.BATH_TIME,
    "DAILY_SLEEP": CommentCategory.DAILY_SLEEP,
    "DAILY_SLEEP_COUNT": CommentCategory.DAILY_SLEEP_COUNT,
    "LAUNDRY_COUNT": CommentCategory.LAUNDRY_COUNT,
    "LAUNDRY_TIME": CommentCategory.LAUNDRY_TIME,
    "MEAL_COUNT": CommentCategory.MEAL_COUNT,
    "MEAL_TIME": CommentCategory.MEAL_TIME,
    "NIGHTLY_TOILET_COUNT": CommentCategory.NIGHTLY_TOILET_COUNT,
    "NIGHTLY_LAUNDRY": CommentCategory.NIGHTLY_LAUNDRY,
    "NIGHTLY_SWEEPING": CommentCategory.NIGHTLY_SWEEPING,
    "NIGHTLY_TV": CommentCategory.NIGHTLY_TV,
    "NIGHTLY_SLEEP_TIME": CommentCategory.NIGHTLY_SLEEP_TIME,
    "NIGHTLY_SLEEP_COUNT": CommentCategory.NIGHTLY_SLEEP_COUNT,
    "SWEEPING_COUNT": CommentCategory.SWEEPING_COUNT,
    "SWEEPING_TIME": CommentCategory.SWEEPING_TIME,
    "TOILET_COUNT": CommentCategory.TOILET_COUNT,
    "TOILET_TIME": CommentCategory.TOILET_TIME,
    "TV_TIME": CommentCategory.TV_TIME,
};

export const getCommentCategoryFromValue = (value: string): CommentCategory | undefined => {
    return mapValueToCategory[value];
};

export type CommentCategoryData = {
    label: string,
    textColor: string,
    bgColor: string,
    estimatedBehaviorCategory: EstimatedBehaviorCategory,
};

export const getCommentCategoryData = (category: CommentCategory): CommentCategoryData => {
    switch (category) {
        case CommentCategory.NIGHTLY_SLEEP_COUNT: {
            return {
                label: "睡眠回数",
                textColor: "#3EC1CB",
                bgColor: "#F4FAFB",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.SLEEP,
            };
        }
        case CommentCategory.NIGHTLY_SLEEP_TIME: {
            return {
                label: "睡眠時間",
                textColor: "#3EC1CB",
                bgColor: "#F4FAFB",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.SLEEP,
            };
        }
        case CommentCategory.TOILET_TIME: {
            return {
                label: "トイレ時間",
                textColor: "#FC6052",
                bgColor: "#FFEDEB",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.TOILET,
            };
        }
        case CommentCategory.TOILET_COUNT: {
            return {
                label: "トイレ回数",
                textColor: "#FC6052",
                bgColor: "#FFEDEB",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.TOILET,
            };
        }
        case CommentCategory.NIGHTLY_TOILET_COUNT: {
            return {
                label: "夜間トイレ回数",
                textColor: "#FC6052",
                bgColor: "#FFEDEB",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.TOILET,
            };
        }
        case CommentCategory.BATH_TIME: {
            return {
                label: "入浴時間",
                textColor: "#6FBFEB",
                bgColor: "#ECFAFE",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.BATH,
            };
        }
        case CommentCategory.BATH_COUNT: {
            return {
                label: "入浴回数",
                textColor: "#6FBFEB",
                bgColor: "#ECFAFE",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.BATH,
            };
        }
        case CommentCategory.MEAL_TIME: {
            return {
                label: "調理準備時間",
                textColor: "#FF6B94",
                bgColor: "#FFEBF0",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.MEAL,
            };
        }
        case CommentCategory.MEAL_COUNT: {
            return {
                label: "調理準備回数",
                textColor: "#FF6B94",
                bgColor: "#FFEBF0",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.MEAL,
            };
        }
        case CommentCategory.SWEEPING_TIME: {
            return {
                label: "掃除時間",
                textColor: "#1EA179",
                bgColor: "#EEFCF8",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.SWEEPING,
            };
        }
        case CommentCategory.SWEEPING_COUNT: {
            return {
                label: "掃除回数",
                textColor: "#1EA179",
                bgColor: "#EEFCF8",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.SWEEPING,
            };
        }
        case CommentCategory.NIGHTLY_SWEEPING: {
            return {
                label: "夜間掃除",
                textColor: "#1EA179",
                bgColor: "#EEFCF8",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.SWEEPING,
            };
        }
        case CommentCategory.LAUNDRY_TIME: {
            return {
                label: "洗濯時間",
                textColor: "#F99E36",
                bgColor: "#FEF5EB",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.LAUNDRY,
            };
        }
        case CommentCategory.LAUNDRY_COUNT: {
            return {
                label: "洗濯回数",
                textColor: "#F99E36",
                bgColor: "#FEF5EB",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.LAUNDRY,
            };
        }
        case CommentCategory.NIGHTLY_LAUNDRY: {
            return {
                label: "夜間洗濯",
                textColor: "#F99E36",
                bgColor: "#FEF5EB",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.LAUNDRY,
            };
        }
        case CommentCategory.DAILY_SLEEP: {
            return {
                label: "午睡",
                textColor: "#3EC1CB",
                bgColor: "#F4FAFB",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.SLEEP,
            };
        }
        case CommentCategory.DAILY_SLEEP_COUNT: {
            return {
                label: "午睡回数",
                textColor: "#3EC1CB",
                bgColor: "#F4FAFB",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.SLEEP,
            };
        }
        case CommentCategory.TV_TIME: {
            return {
                label: "テレビ時間",
                textColor: "#F2D818",
                bgColor: "#FEFCEC",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.TV,
            };
        }
        case CommentCategory.NIGHTLY_TV: {
            return {
                label: "夜間テレビ",
                textColor: "#F2D818",
                bgColor: "#FEFCEC",
                estimatedBehaviorCategory: EstimatedBehaviorCategories.TV,
            };
        }
    }
};
